import { Sort } from '@tunasong/icons'
import { Menu, MenuContent, MenuRadioGroup, MenuRadioItem, MenuTrigger } from '@tunasong/ui-lib'
import type { FC } from 'react'
import type { SpaceSortOrder } from './space-sort.js'
import { isSpaceSortOrder, spaceSortLabels, spaceSortOrders } from './space-sort.js'
import styles from './spaces-sort-menu.module.css'

export interface SpacesSortMenuProps {
  value: SpaceSortOrder
  onChange(order: SpaceSortOrder): void
}

/**
 * A quiet "Sort" button for Home's Spaces header. The visible label stays "Sort"; the accessible name carries
 * the current order. Picking an order closes the menu, and Base UI returns focus to the button.
 */
export const SpacesSortMenu: FC<SpacesSortMenuProps> = props => {
  const { value, onChange } = props

  const handleValueChange = (next: unknown) => {
    if (isSpaceSortOrder(next)) {
      onChange(next)
    }
  }

  return (
    <Menu>
      <MenuTrigger className={styles.trigger} aria-label={`Sort spaces: ${spaceSortLabels[value]}`}>
        <Sort size={16} aria-hidden="true" />
        <span className={styles.label}>Sort</span>
      </MenuTrigger>
      <MenuContent className={styles.menu}>
        <MenuRadioGroup value={value} onValueChange={handleValueChange}>
          {spaceSortOrders.map(order => (
            <MenuRadioItem key={order} value={order} closeOnClick>
              {spaceSortLabels[order]}
            </MenuRadioItem>
          ))}
        </MenuRadioGroup>
      </MenuContent>
    </Menu>
  )
}
